<template>
  <div class="publication-accordion">
    <h2 v-if="title" class="publication-accordion__title h3">{{ title }}</h2>

    <div
      v-for="item in items"
      :key="item.index"
      class="publication-accordion__item"
      :class="{ '-open': isOpen(item.index) }"
    >
      <button
        type="button"
        class="publication-accordion__head t1"
        :aria-expanded="isOpen(item.index)"
        :aria-controls="panelId(item.index)"
        @click="toggle(item.index)"
      >
        <span class="publication-accordion__head-text">{{ item.title }}</span>
        <!-- Размер `-l` (дефолт) — 32px по макету; он же `--t1-line-height`. -->
        <FontIcon
          class="publication-accordion__head-icon"
          :class="isOpen(item.index) ? 'arrow_up' : 'arrow_down'"
        />
      </button>

      <div
        :id="panelId(item.index)"
        class="publication-accordion__panel"
        :inert="!isOpen(item.index)"
      >
        <CmsContent
          v-if="item.text.length"
          class="publication-accordion__text html-editor -content"
          :html="item.text"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  /*=== Import ===*/
  import { CmsContent } from '@nuxt-shared/ui/cms-content';
  import { FontIcon } from '@nuxt-shared/ui/font-icon';
  import { usePublicationAccordionModel } from './model';
  import type { PublicationAccordionProps } from './types';

  const props = defineProps<PublicationAccordionProps>();

  const { items, title, isOpen, panelId, toggle } = usePublicationAccordionModel(props);
</script>

<style lang="scss">
  @use './style.scss';
</style>
